var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { nl2br, targetBlankifyLinks } from '../../../lib/helpers';
import { ErrorMsg } from '../../error-msg';
export var CheckboxField = function (_a) {
    var data = _a.data, value = _a.value, inputValueChange = _a.inputValueChange;
    var values = data.field_options.options.map(function (a) { return a.value; });
    var selectedItems = values.reduce(function (selected, item) {
        var _a;
        if ((_a = value.value) === null || _a === void 0 ? void 0 : _a.includes(item)) {
            return __spreadArray(__spreadArray([], selected, true), [item], false);
        }
        return selected;
    }, []);
    var onChange = function (e) {
        var newValue;
        if (e.target.checked) {
            var oldValue = value.value.split(',');
            newValue = value.value
                ? __spreadArray(__spreadArray([], oldValue, true), [e.target.value], false).join(',')
                : e.target.value;
        }
        else {
            newValue = selectedItems
                .filter(function (value) { return value !== e.target.value; })
                .join(',');
        }
        inputValueChange(data.qid, 'textInput', newValue);
    };
    var labelHtml = {
        __html: nl2br(targetBlankifyLinks(data.label)),
    };
    var labelId = "checkbox-group-".concat(data.qid);
    return (_jsx("div", __assign({ className: data.className ? data.className : 'col-xs-12' }, { children: _jsxs("div", __assign({ className: "input-line input-checkbox" }, { children: [data.label && (_jsxs("label", __assign({ id: labelId, htmlFor: data.qid, dir: "auto" }, { children: [_jsx("span", { dangerouslySetInnerHTML: labelHtml }, void 0), ' ', _jsx("span", __assign({ className: "fieldRequired" }, { children: data.required && '*' }), void 0)] }), void 0)), data.field_options.options.map(function (checkbox) { return (_jsxs("label", __assign({ className: data.errorMessage
                        ? 'label-checkbox label-checkbox-error'
                        : 'label-checkbox', dir: "auto" }, { children: [_jsx("input", { dir: "auto", type: "checkbox", name: data.qid, checked: selectedItems.includes(checkbox.value), value: checkbox.value, onChange: onChange }, void 0), _jsx("span", { dangerouslySetInnerHTML: {
                                __html: checkbox.label,
                            } }, void 0)] }), '' + data.qid + checkbox.value)); }), data.errorMessage && (_jsx(ErrorMsg, { id: data.qid, error: data.errorMessage }, void 0))] }), void 0) }), data.qid));
};
